<template>
<div class="chapter">
<div class="inner_page">
<p class="chtitle">VISUAL GUIDE</p>
<p class="figx"><img alt="" src="images/pg6.jpg"/></p>
<p class="h1">LAZY DAISY AND CHAIN STITCHES</p>
<p class="noindents">The lazy daisy stitch can be stitched as a single unit or shape or can be repeated to create a border row. The chain stitch can be stitched as a border row or used to outline a shape.</p>
<p class="fig"><img alt="image" src="images/pg7.jpg"/></p>
<p class="h1">FLY AND FEATHER STITCHES</p>
<p class="noindents">The fly stitch can be stitched as a single unit or shape or can be repeated to create a border row. The feather stitch can be stitched as a border row or used to outline a shape.</p>
<p class="fig"><img alt="image" src="images/pg7-1.jpg"/></p>
<blockquote class="Caption"><i>Primarily Crazy for Kevin</i>, project inspiration for CQ Sewing Caddy</blockquote>
<p class="h1">CONTINUOUS BEAD AND BLANKET STITCHES</p>
<p class="noindents">The continuous bead and blanket stitches can be stitched as a border row or used to outline a shape.</p>
<p class="fig"><img alt="image" src="images/pg8.jpg"/></p>
<p class="h1">CROSS, HERRINGBONE, SERPENTINE, AND CRETAN STITCHES</p>
<p class="noindents">The cross stitch can be used as a single unit or as a border row. The herringbone, serpentine, and cretan stitches can be used as a border row stitch.</p>
<p class="fig"><img alt="image" src="images/pg8-1.jpg"/></p>
<p class="h1">FLOWERS AND EXTRA STITCHES</p>
<p class="noindents">These are all individual stitches that can placed into an open area or grouped together as a vignette.</p>
<p class="fig"><img alt="image" src="images/pg9.jpg"/></p>
<p class="h1">DECORATIVE AND DETAIL STITCHES</p>
<p class="noindents">These stitches can be worked as a single unit, grouped together in a cluster, or used as a border row.</p>
<p class="fig"><img alt="image" src="images/pg9-1.jpg"/></p>
<p class="h1">BUTTON AND SEQUIN FLOWERS</p>
<p class="noindents">These are all individual stitches that can be stitched here and there or grouped together as vignettes.</p>
<p class="fig"><img alt="image" src="images/pg10.jpg"/></p>
<p class="h1">BEADED EDGES</p>
<p class="noindents">These stitches can be added to the finished edge of a project to add a little sparkle.</p>
<p class="fig"><img alt="image" src="images/pg10-1.jpg"/></p>
<p class="h1">EVEN PEYOTE AND FREE-FORM PEYOTE STITCHES</p>
<p class="noindents">These stitches are worked onto the fabric following a straight or curved line.</p>
<p class="fig"><img alt="image" src="images/pg11.jpg"/></p>
<p class="h1">CIRCULAR PEYOTE AND NETTED STITCHES</p>
<p class="noindents">These stitches are worked as individual units and then attached to the fabric base.</p>
<p class="fig"><img alt="image" src="images/pg11-1.jpg"/></p>
<p class="h1">BRICK STITCHES</p>
<p class="noindents">These stitches are worked as individual units and then attached to the fabric base.</p>
<p class="fig"><img alt="image" src="images/pg11-2.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_chapter01.vue?8fcffbae